import styled from "styled-components";

const BPSCheckmarkList = styled.div`

    margin-bottom: 1rem;
    
    ul {
        list-style: none;
        font-size: 1.125rem;
        color: #4d4d4d;
        font-family: 'Mulish', sans-serif !important;
        margin: 0;
        padding: 0;
    }

    li {
        padding: .125rem 0rem;

        svg {
            fill: #0478c2
        }
    }
`

const Checkmark = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#0478c2" className="me-2"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>
        </>
    );
}


export { BPSCheckmarkList, Checkmark }
